import React, { FC, useEffect } from "react";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Description } from "@/components/YhBox/Description";
import { useSalesDetailModel } from "./salesDetailModel";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { Button, Dropdown, Menu, message, Modal, Radio } from "antd";
import { getFormValidatorErrText } from "@/utils/utils";
import { ValidateErrorEntity } from "rc-field-form/es/interface";
import TextArea from 'antd/lib/input/TextArea';
import { ISalesExamine } from '../../salesTypes';
// import { usePurchasesDetailModel } from "@/views/purchases/view/details/purchasesDetailModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { useShipmentDetailModel } from "@/views/shipment/view/details/shipmentDetailModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";

export const TopButs: FC<RouterParamType> = ({ id, mode, formRef }) => {
    const {
        editFormVal,
        editFormVal: { status },
        getSalesDetailOne,
        resetPageCache,
        insertOrUpdateSales,
        submitSales, examineManager, examineReckoner,
        whConfirm,
        transferShipping, transferPurchase, setSettleVisible, setSettlementVisible,
        transferCustoms
    } = useSalesDetailModel();
    const { getTreeNodeName } = useDictModel(() => []);
    // const { updateFormVal: purchaseUpdateFormVal } = usePurchasesDetailModel(() => []);
    const { selectedNavId, replaceNav, findNav } = useNavModel(({ selectedNavId }) => [selectedNavId]);
    const { updateFormVal: shipmentUpdateFormVal } = useShipmentDetailModel(() => []);

    const isEdit = mode === "edit";

    useEffect(() => {
        if (!editFormVal.id && isEdit) {
            getSalesDetailOne(id)
        }
    }, [mode]);

    //关闭页签的时候清除对应缓存
    useEffect(() => {
        return () => {
            !findNav("3-1") && resetPageCache("add")
            !findNav("3-2") && resetPageCache("edit");
        }
    }, [selectedNavId])

    const orderStatu: IDescription[] = [
        {
            label: "外贸合同号",
            value: mode === "edit" ? editFormVal.realCode : "",
            color: DescriptionColorEnum.blue,
            status: true
        },
        {
            label: "状态",
            value: mode === "edit" ? getTreeNodeName(status ?? "") : "",
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: "驳回原因",
            value: editFormVal.status === DictCodeEnmu.SALES_DIR_REJECT ? editFormVal.advise ?? "" : editFormVal.adviseOne ?? "",
            color: DescriptionColorEnum.red,
            status: true,
            hidden: mode === "add" || !(status === DictCodeEnmu.SALES_DIR_REJECT || status === DictCodeEnmu.SALES_FIN_REJECT) //财务 或者 总监已驳回时  展示驳回原因
        }
    ]

    //表单提交
    const onSubmit = () => {
        formRef.current?.validateFields().then((val: any) => {
            insertOrUpdateSales(mode, val).then(res => {
                if (mode === "add" && res) {
                    resetPageCache("edit");
                    replaceNav("3-1", "3-2", { id: res, mode: "edit" });
                }
            })
        }).catch((err: ValidateErrorEntity<any>) => {
            message.warning(getFormValidatorErrText(err));
        })
    };

    const printMenu = (
        <Menu>
            {/* <Menu.Item key="2" onClick={() => { }}>
                销售合同
            </Menu.Item>
            <Menu.Item key="0" onClick={() => { }}>
                商业发票
            </Menu.Item>
            <Menu.Item key="1" onClick={() => { }}>
                装箱单
            </Menu.Item> */}
        </Menu>
    );

    //审批弹框
    const examineModal1 = (title: string) => {
        let obj: ISalesExamine = {
            status: "0",//默认是同意
            title
        }
        Modal.confirm({
            title: title,
            content: <>
                <TextArea rows={4} placeholder="请输入审批意见" onChange={(e) => { obj.advise = e.target.value }} />
                <Radio.Group onChange={(e) => { obj.status = e.target.value }} defaultValue={obj.status}>
                    <Radio value={"0"}>同意</Radio>
                    <Radio value={"1"}>驳回</Radio>
                </Radio.Group>
            </>,
            okText: '确定',
            cancelText: '取消',
            onOk: () => {
                return new Promise((resolve, reject) => {
                    // if (obj.advise) {
                    resolve(obj);
                    // } else {
                    // message.warning("请输入审批意见");
                    // reject('请输入审批意见');
                    // }
                }).then((res: any) => {
                    examineManager({
                        code: editFormVal.code,
                        status: res.status,
                        advise: res.advise,
                    })
                });
            },
            onCancel: () => { }
        })
    }

    //审批弹框
    const examineModal2 = (title: string) => {
        let obj: ISalesExamine = {
            status: "0",//默认是同意
            title
        }
        Modal.confirm({
            title: title,
            content: <>
                <TextArea rows={4} placeholder="请输入审批意见" onChange={(e) => { obj.advise = e.target.value }} />
                <Radio.Group onChange={(e) => { obj.status = e.target.value }} defaultValue={obj.status}>
                    <Radio value={"0"}>同意</Radio>
                    <Radio value={"1"}>驳回</Radio>
                </Radio.Group>
            </>,
            okText: '确定',
            cancelText: '取消',
            onOk: () => {
                return new Promise((resolve, reject) => {
                    // if (obj.advise) {
                    resolve(obj);
                    // } else {
                    // message.warning("请输入审批意见");
                    // reject('请输入审批意见');
                    // }
                }).then((res: any) => {
                    examineReckoner({
                        code: editFormVal.code,
                        status: res.status,
                        advise: res.advise,
                    })
                });
            },
            onCancel: () => { }
        })
    }

    const action = <>
        {isEdit && <>
            <YhAuth resCode={ResourceAuthEnum.S_ED_SUBMIT}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    disabled={
                        !(status === DictCodeEnmu.SALES_INIT ||
                            status === DictCodeEnmu.SALES_DIR_REJECT ||
                            status === DictCodeEnmu.SALES_FIN_REJECT)
                    }
                    onClick={() => {
                        submitSales(editFormVal.id)
                    }}
                >提交审核</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.S_ED_APPROVE}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    disabled={!(status === DictCodeEnmu.SALES_PEND_APPROVE)}
                    onClick={() => examineModal1("总监审批")}
                >总监审批</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.S_ED_FIN_APPROVE}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    disabled={!(status === DictCodeEnmu.SALES_DIR_APPROVE)}
                    onClick={() => examineModal2("财务审批")}
                >财务审核</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.S_ED_SETTLE}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    disabled={!(status === DictCodeEnmu.SALES_PEND_SETTLE)}
                    onClick={() => { setSettleVisible(true) }}
                >结算</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.S_ED_COLLECT}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    disabled={!(status === DictCodeEnmu.SALES_SETTLE || status === DictCodeEnmu.SALES_SHIP || status === DictCodeEnmu.SALES_PEND_SHIP || status === DictCodeEnmu.SALES_EX_WAREHOUSE)}
                    onClick={() => { setSettlementVisible(true) }}
                >结汇</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.S_ED_TRANS}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    disabled={
                        !(status === DictCodeEnmu.SALES_SETTLE || status === DictCodeEnmu.SALES_SETTLEMENT)
                    }
                    onClick={() => {
                        transferPurchase().then(res => {
                            if (res) {
                                // purchaseUpdateFormVal("edit", null);
                                replaceNav("3-2", "4")
                            }
                        })
                    }}
                >转采购合同</Button>
            </YhAuth>
            {/* <YhAuth resCode={ResourceAuthEnum.S_ED_OUT}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    disabled={!()}
                    onClick={() => whConfirm()}
                >出库</Button>
            </YhAuth> */}
            <YhAuth resCode={ResourceAuthEnum.S_ED_SHIP}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    disabled={!(status === DictCodeEnmu.SALES_PEND_SHIP || status === DictCodeEnmu.SALES_SETTLE || status === DictCodeEnmu.SALES_SETTLEMENT)}
                    onClick={() => transferShipping().then(res => {
                        if (res) {
                            shipmentUpdateFormVal(null);
                            replaceNav("3-2", "5-2", { id: res as string, mode: "edit" });
                        }
                    })}
                >发运</Button>
            </YhAuth>
            {/* <YhAuth resCode={ResourceAuthEnum.S_ED_PRINT}>
                <Dropdown overlay={printMenu} trigger={['hover']}>
                    <Button
                        className="mr-5"
                        type="link"
                        shape="round"
                        onClick={() => { }}
                    >制单合同</Button>
                </Dropdown>
            </YhAuth> */}
            <YhAuth resCode={ResourceAuthEnum.S_ED_TURNB}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    disabled={!(status === DictCodeEnmu.SALES_SHIP)}
                    onClick={() => {
                        transferCustoms().then(res => {
                            if (res) {
                                replaceNav("3-2", "9-2")
                            }
                        })
                    }}
                >转报关单据</Button>
            </YhAuth>
        </>}
        <YhAuth resCode={ResourceAuthEnum.S_ED_SAVE} isShow={mode === "add"}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => { onSubmit() }}
            >保存</Button>
        </YhAuth>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => replaceNav(selectedNavId, "3")}
        >返回</Button>
    </>

    return (
        <YhBox title={orderStatu.map((item, index) => <Description key={index} {...item} />)}
            style={{ paddingBottom: 0, marginBottom: "10px" }}
            action={action}
        />
    )
}